export const advisoryMembers = [
  {
    name: 'Mr. Ashok Dalwai',
    photo: '/images/members/Dr-Ashok-Dalwai.jpg',
    initials: 'AD',
    gradClass: 'ag1',
    bio: 'Dr. Ashok Dalwai, an Indian Administrative Service officer of the 1984 batch, currently serves as CEO of the National Rainfed Area Authority (NRAA) under the Ministry of Agriculture and Farmers Welfare. As Chairman of the Inter-Ministerial Committee on Doubling Farmers\u2019 Income (DFI), his 14-volume report is regarded as a transformative roadmap for agricultural prosperity.',
  },
  {
    name: 'Dr. Dennis Garrity',
    photo: '/images/members/Dennis.jpg',
    initials: 'DG',
    gradClass: 'ag2',
    bio: 'Dr. Dennis Garrity is a systems agronomist and global leader in sustainable agriculture. Currently Chair of the Board of the Global EverGreening Alliance and Drylands Ambassador for the UN Convention to Combat Desertification, he champions agroforestry and community-driven landcare to restore degraded lands.',
  },
  {
    name: 'Rajit R. Okhandiar',
    photo: '/images/members/Rajit.jpg',
    initials: 'RO',
    gradClass: 'ag3',
    bio: 'Rajit R. Okhandiar serves as the National Forestry Expert at FAO. He specializes in sustainable harvesting and value addition of Non-Timber Forest Products (NTFPs), providing capacity-building training and leading initiatives to develop small forest enterprises.',
  },
  {
    name: 'Mr. Tomio Shichiri',
    photo: '/images/members/Tomio.jpg',
    initials: 'TS',
    gradClass: 'ag4',
    bio: 'Tomio Shichiri served as the FAO Country Director / Representative in India from 2018. He led as co-organizer of the National Dialogue on Indian Agriculture Toward 2030 and collaborated with NITI Aayog, MoAFW, and multiple ministries on agriculture and sustainability initiatives.',
  },
];

export const advisoryMembersRow2 = [
  {
    name: 'Virendra Pal Singh',
    photo: '/images/members/Virendra.jpg',
    initials: 'VS',
    gradClass: 'ag5',
    bio: 'Virendra Pal Singh is a Soil Scientist and Systems Agronomist, Senior Advisor for Policy and Impact at ICRAF-South Asia. He served as ICRAF\u2019s founding Regional Director for South Asia from 2003 to 2014 and successfully organized the 3rd World Congress of Agroforestry in New Delhi.',
  },
  {
    name: 'Sreenivasa Murthy',
    photo: '/images/members/sreenivasa-murthy.jpeg',
    initials: 'SM',
    gradClass: 'ag6',
    bio: 'Sreenivasa Murthy is a retired Indian Forest Service officer (1987-2020) in Madhya Pradesh. As Field Director of Panna Tiger Reserve, he led the world-famous Panna Tiger Reintroduction from zero to 32 tigers between 2009 and 2015.',
  },
  {
    name: 'Amarendra Mohan',
    photo: '/images/members/Amarendra-Mohan.jpeg',
    initials: 'AM',
    gradClass: 'ag7',
    bio: 'Amarendra Mohan is an independent advisor specializing in financial sector regulation, supervision, and financial stability. He has held senior roles at the Reserve Bank of India, the BIS Financial Stability Institute, and The SEACEN Centre.',
  },
];
